<template>
<div class="main">

<modelMenu></modelMenu>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="handleEdit(edit, null)"
        >
          新增model
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="关键词(匹配标题)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="图标"
        prop="basic.avatar"
        show-overflow-tooltip
      >
      <template #default="{ row }">
          <img class="avatar" :src="row.basic.avatar" alt="">
      </template>
      </el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleEdit(edit, row)">
            编辑
          </el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { createModel, updateModel,removeModel,findModel,findModelList } from '@/api/model'
  import Edit from './edit.vue'
  import { reactive, ref, getCurrentInstance } from 'vue'
  import { getAllBranchs } from '@/api/branch'
  import ModelMenu from '../index.vue'
  export default {
    name: 'OaCarIndex',
    components: { Edit, ModelMenu },
    setup() {
      const { proxy } = getCurrentInstance()
      const list = reactive([])
      const stepList = [
        {
          label: '已生效',
          value: 1,
        },
        {
          label: '待生效',
          value: 2,
        },
      ]
      const listLoading = ref(true)
      const layout = 'total, sizes, prev, pager, next, jumper'
      const total = ref(0)
      const queryForm = reactive({
        page: 1,
        size: 10,
        createPeopleId: '',
        followPeopleId: '',
        branchId: '',
        step: '',
        keyword: '',
      })
      const edit = ref(null)
      const fetchData = async () => {
        listLoading.value = true
        const { list: list1, total: total1 } = await findModelList(queryForm)
        list.length = 0
        list.push(...list1)
        total.value = total1
        listLoading.value = false
      }
      const queryData = () => {
        queryForm.page = 1
        fetchData()
      }
      //添加和编辑
      const handleEdit = (edit, row) => {
        edit.showEdit(row)
      }
      const handleDelete = (row) => {
        proxy.$baseConfirm(
          `你确定要删除model：${row.title} 吗`,
          null,
          async () => {
            await removeModel({
              modelId: row.modelId,
            })
            proxy.$baseMessage(
              `删除model成功`,
              'success',
              false,
              'vab-hey-message-success'
            )
            queryData()
          }
        )
      }
      //分页
      const handleSizeChange = (val) => {
        queryForm.size = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        queryForm.page = val
        fetchData()
      }
      //拉取数据
      queryData()
      return {
        list,
        listLoading,
        layout,
        total,
        queryForm,
        moment,
        edit,
        stepList,
        fetchData,
        queryData,
        handleEdit,
        handleDelete,
        handleSizeChange,
        handleCurrentChange,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .main{
    display: flex;
  }
  .user-management-container{
    padding: 10px;
    width: 100%;
  }
  .diy-dropdown-menu {
    padding: 8px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  .el-button {
    margin-left: 0px !important;
    margin-bottom: 6px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .pr-10 {
    padding-right: 10px;
  }
  .el-dropdown-link {
    font-size: 12px;
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .avatar {
    height: 64px;
    width: 64px;
    border-radius: 8px;
  }
  .big-avatar {
    height: 64px;
    width: 128px;
    border-radius: 8px;
  }
</style>
